// Match the sending window, so repeated embeds of the same widget resize separately.
export function widgetFrameStyle(appearance) {
  const margins = ['marginTop', 'marginRight', 'marginBottom', 'marginLeft'].map(key => {
    const value = appearance?.[key];
    return typeof value === 'number' && Number.isFinite(value) ? Math.round(Math.max(0, Math.min(160, value))) : 0;
  });
  const horizontal = margins[1] + margins[3];
  return `width:${horizontal ? `calc(100% - ${horizontal}px)` : '100%'};border:0;display:block;height:150px;min-height:0;margin:${margins.map(value => value + 'px').join(' ')};`;
}

export function widgetResizeScript(widgetKey, widgetUrl) {
  const origin = new URL(widgetUrl).origin;
  return `(function () {
  window.addEventListener('message', function (event) {
    var data = event.data;
    if (event.origin !== ${JSON.stringify(origin)} || !data || data.type !== 'widget-resize') return;
    if (data.widgetId !== ${JSON.stringify(widgetKey)} || typeof data.height !== 'number' || !Number.isFinite(data.height) || data.height <= 0 || data.height > 100000) return;
    document.querySelectorAll('iframe[data-pipsqueak-widget]').forEach(function (frame) {
      if (frame.getAttribute('data-pipsqueak-widget') !== data.widgetId || frame.contentWindow !== event.source) return;
      frame.style.minHeight = '0px';
      frame.style.height = Math.ceil(data.height) + 'px';
      var margins = data.margins;
      if (Array.isArray(margins) && margins.length === 4 && margins.every(function (value) { return typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= 160; })) {
        frame.style.margin = margins.map(function (value) { return value + 'px'; }).join(' ');
        frame.style.width = (margins[1] + margins[3]) ? 'calc(100% - ' + (margins[1] + margins[3]) + 'px)' : '100%';
      }
    });
  });
})();`;
}
